import { Helmet } from "react-helmet-async";
// @mui
import { styled } from "@mui/material/styles";
import {
  Typography,
  Container,
  Grid,
  Button,
  createTheme,
  ThemeProvider,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Link,
  Stack,
  IconButton,
  Box,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";
import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import * as queries from '../graphql/queries';
import * as customqueries from '../graphql/customqueries';
import { API, Auth } from 'aws-amplify';
// Styles from previous site
import "./HomePage.css";
import { useEffect, useState } from "react";
import { Gradient } from "src/utils/Gradient";
import {
  Email,
  PlayCircle,
  PlayCircleOutline,
  SportsEsports,
} from "@mui/icons-material";
import Marquee from "react-fast-marquee";
import { fontSize, textAlign, useTheme } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitch, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useAuthContext } from "src/auth/useAuthContext";
import useOffSetTop from '../hooks/useOffSetTop';
// config
import { HEADER } from '../config-global';
import Header from "src/layouts/simple/Header";

// ----------------------------------------------------------------------

const ImgContainer = styled('div')`
  width: 600px;
  height: 600px;
  position: absolute;
  left: 60%;
  top: 0;
`;

const ImgContainerBottom = styled('div')`
  width: 500px;
  height: 500px;
  position: absolute;
  left: 25%;
  bottom: 0;
`;

const ImgContainer2 = styled('div')`
  width: 600px;
  height: 600px;
  position: absolute;
  right: 50%;
  top: 0;
`;

const ImgContainerBottom2 = styled('div')`
  width: 500px;
  height: 500px;
  position: absolute;
  right: 25%;
  bottom: 0;
`;

const StyledImage = styled('img')`
  max-width: unset;
  height: 100%;
`;

const StyledInput = styled("input")`StyledInput
  display: block;
width: 100%;
padding: .375rem .75rem;
font-size: 1rem;
font-weight: 400;
line-height: 1.5;
color: #212529;
background-color: #fff;
background-clip: padding-box;
border: 1px solid #ced4da;
-webkit-appearance: none;
-moz-appearance: none;
appearance: none;
border-radius: .375rem;
transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
`;

const GameLogo = styled('img')`
  width: 150px !important;
  height: auto !important;
  max-width: unset;
  margin-top: 60px;
  object-fit: contain !important;
`;

const GameLogoContainer = styled(Grid)`
-webkit-box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.56);
-moz-box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.56);
box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.56);
`;

const FGNImage = styled('img')`
-webkit-box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.56);
-moz-box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.56);
box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.56);
`;

const StyledRightArrowBackground = styled('div')`
${props => props.theme.breakpoints.up("md")} {
-webkit-clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
}
background: rgb(25,66,113);
background: radial-gradient(circle at left bottom, rgba(25,66,113,1) 30%, rgba(94,129,89,1) 100%);
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
height: 100%;
width: 100%;

`;

const LogoHex = styled('div')`
  -webkit-clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
  clip-path: polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%);
`;
// ----------------------------------------------------------------------
let scrolling = false;

const theme = createTheme({
  palette: {
    mode: 'dark'
  },
  typography: {
    "fontFamily": `"Metropolis"`,
    "fontWeightLight": 300,
    "fontWeightRegular": 500,
    "fontWeightMedium": 600,
    "fontWeightBold": 800
  }
});

export default function HomePage() {
  const [sections, setSections] = useState();
  const minimalTheme = useTheme();
  const { user } = useAuthContext();
  const isMd = useMediaQuery(theme => theme.breakpoints.up('md'))

  useEffect(() => {
    // const contact_form_API = "https://api.fibergamingnetwork.com/contact";
    // const form = document.getElementById("contact-form");
    // const currentFormItems = form.querySelectorAll("input, .form-control, .btn")

    // form.addEventListener("submit", (e) => {
    //   e.preventDefault();

    //   const myFormData = new FormData(e.target);

    //   const formDataObj = Object.fromEntries(myFormData.entries());

    //   console.log(formDataObj);

    //   const formDataObjJSON = JSON.stringify(formDataObj);

    //   sendMessage(
    //     currentFormItems,
    //     contact_form_API,
    //     formDataObjJSON,
    //     function (server_response) {
    //       if (typeof server_response["successful"] === "object") {
    //         const sent_text = form.querySelector(".message-sent");
    //         sent_text.classList.remove("text-danger");
    //         sent_text.classList.add("txt-white");
    //         sent_text.innerText = "Thanks for joining!";
    //         sent_text.classList.add("message-sent-show");
    //       } else {
    //         currentFormItems.forEach((item) => {
    //           item.disabled = false;
    //         });
    //         const error_text = form.querySelector(".message-sent");
    //         error_text.classList.add("text-danger");
    //         error_text.innerText = "Error submitting. Please try again.";
    //         error_text.classList.add("message-sent-show");
    //         setTimeout(() => {
    //           error_text.classList.remove("message-sent-show");
    //         }, 4000);
    //       }
    //       console.log(server_response["successful"]);
    //     }
    //   );
    // });

    let gradient = new Gradient();
    gradient.initGradient("#gradient-canvas");

    var scrolling = false;
    var scroll_timeout = null;

    function start_scroll_timeout() {
      scrolling = true;
      window.clearTimeout(scroll_timeout);
      scroll_timeout = setTimeout(() => {
        scrolling = false;
      }, 750);
    }

    window.addEventListener("scroll", () => {
      start_scroll_timeout();
    });

    window.addEventListener("touchstart", () => {
      start_scroll_timeout();
    });

    window.addEventListener("touchend", () => {
      start_scroll_timeout();
    });

    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", () => {
      console.log("resize (scrolling): " + scrolling);
      if (!scrolling) {
        appHeight();
      }
    });
    appHeight();

    // Scroll Down Functionality
    setSections(document.querySelectorAll("[data-scroll-to]"));
  }, []);

  const scrollToSection = (element) => {
    if (!element) {
      let nextScroll = {
        scrollPos: window.innerHeight,
        element: null,
      };

      let sectionChosen = false;
      sections.forEach((section) => {
        if (
          section.getBoundingClientRect().top > 0 &&
          sectionChosen === false
        ) {
          nextScroll["scrollPos"] = section.getBoundingClientRect().top;
          nextScroll["element"] = section;
          sectionChosen = true;
        }
      });

      if (nextScroll["element"] != null) {
        nextScroll["element"].scrollIntoView({ behavior: "smooth" });
      }
    } else {
      var scrolltoelm = document.getElementById(element);
      scrolltoelm.scrollIntoView({ behavior: "smooth" });
    }
  };

  // function sendMessage(currentFormItems, theURL, formdata, callback) {
  //   console.log(`FORM ITEMS: ${currentFormItems}`)
  //   currentFormItems.forEach((item) => {
  //     item.disabled = true;
  //     console.log(item);
  //   });
  //   var xmlHttp = new XMLHttpRequest();
  //   // xmlHttp.onreadystatechange = function() {
  //   //     if (xmlHttp.readyState == 4 && xmlHttp.status == 200){
  //   //         callback(xmlHttp.responseText);
  //   //     } else {
  //   //         callback("error");
  //   //         console.log(formdata);
  //   //     }
  //   // }
  //   xmlHttp.onload = () => {
  //     callback(JSON.parse(xmlHttp.responseText));
  //   };
  //   xmlHttp.open("POST", theURL, true); // true for asynchronous
  //   xmlHttp.send(formdata);
  // }

  const [providerSelection, setProviderSelection] = useState();
  const [loadingProviders, setLoadingProviders] = useState(false);
  const [providers, setProviders] = useState('');
  const [provider, setProvider] = useState('');
  const listProviders = () => {
    setLoadingProviders(true)
    async function fetchAllProviders() {
      let providers = [];
      let nextToken = null;
      let hasNextPage = true;

      while (hasNextPage) {
        const response = await API.graphql({
          query: customqueries.listProviderProfiles,
          authMode: GRAPHQL_AUTH_MODE.API_KEY,
          variables: { nextToken },
        });

        const { items, nextToken: newNextToken } = response.data.listProviderProfiles;

        providers = [...providers, ...items];
        nextToken = newNextToken;
        hasNextPage = Boolean(nextToken);
      }

      return providers;
    }

    const getProviders = async () => {
      try {
        const allProviders = await fetchAllProviders();
        console.log(allProviders);
        setProviders(allProviders.filter(obj => obj.status === "active").sort((a, b) => a.name.localeCompare(b.name)));
        setLoadingProviders(false);

      } catch (err) {
        console.log(err);
      }
    };

    getProviders();

  }
  const handleProviderSelection = (selection) => {
    setProviderSelection(selection);
    console.log(selection)
    // window.location = `/register?provider=${selection}`

    if (selection === 'noProvider') {
      handleSelectProvider(selection)
      window.location = `/register`
    } else {
      if (providers[selection].externalAuth) {
        Auth.federatedSignIn({ customProvider: providers[selection].externalAuth }).then(() => {
          // Login was successful
        }).catch(err => {
          // An error occurred
          console.error(err);
          console.log(err);
          console.log(err.response);
          // Here, err should have information about the error that occurred.
          // Depending on the error, err could be a string error message or an object with more details.
        });
      } else {
        window.location = `/register?provider=${providers[selection].slug}`
        // console.log(providers[selection].slug);
      }
    }
  }

  const handleSelectProvider = (index) => {
    if (index !== 'noProvider') {
      setProvider(providers[index].id);
    } else {
      setProvider(index);
    }
  }

  useEffect(() => {
    listProviders();
  }, []);

  useEffect(() => {
    const containerMain = document.querySelector('.container-main');
    if (containerMain) {
      containerMain.classList.add('hp-full-width');
    }

    return function removeBackground() {
      const containerMain = document.querySelector('.container-main');
      if (containerMain) {
        containerMain.classList.remove('hp-full-width');
      }
    }
  }, []);

  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title> Fiber Gaming Network </title>
        <script src="js/Gradient.js"></script>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#414141" />
        <meta name="msapplication-TileColor" content="#414141" />
        <meta name="theme-color" content="#414141" />

        <meta name="title" content="FiberGamingNetwork.com" />
        <meta
          name="description"
          content="Delight Your Subscribers. Attract More Prospects. Dominate the Gamer Market."
        />

        <meta property="og:title" content="FiberGamingNetwork.com" />
        <meta
          property="og:description"
          content="Delight Your Subscribers. Attract More Prospects. Dominate the Gamer Market."
        />
        <meta property="og:image" content="/preview.jpg" />
        <meta property="og:video" content="/fgn-meta-preview.mp4" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="FiberGamingNetwork.com" />
        <meta
          property="twitter:description"
          content="Delight Your Subscribers. Attract More Prospects. Dominate the Gamer Market."
        />
        <meta property="twitter:image" content="/preview.jpg" />
      </Helmet>


      {/* Top Section */}
      {user &&
        <ThemeProvider theme={minimalTheme}>
          <CssBaseline />
          <Header userProfile isOffset={isOffset} />
        </ThemeProvider>
      }
      <Grid item container class="container-main" height='100vh' overflow='hidden' style={{ position: 'relative' }}>
        <canvas
          id="gradient-canvas"
          style={{
            width: "100vw",
            height: '100vh',
            maxWidth: "100vw !important",
            position: "absolute",
            top: "0",
            left: "0",
            bottom: '0',
            zIndex: "-100",
          }}
        ></canvas>
        <Grid item xs="12" marginY="auto" minHeight="100vh" display="flex" position='relative' paddingX={2}>
          <Container
            maxWidth="lg"
            style={{
              marginTop: "auto",
              marginBottom: "auto",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Grid container sx={{ color: "#ffffff" }} alignItems='center'>
              {!user &&
                <Grid item xs={12} sm={6} paddingX={3.5} sx={{ pt: { xs: 15, sm: 8, md: 0 } }}>
                  <Typography
                    component="h1"
                    variant="h1"
                    sx={{ fontWeight: 100, fontSize: { xs: '2em', md: '3.5em' }, fontWeight: '500', textAlign: 'center' }}

                    paddingTop={{ xs: 2, sm: 0 }}
                  >
                    Play, Stream, Win!
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '0.8rem', md: '1rem'}}} mt={1} textAlign='center' fontWeight='600'>
                    Select your internet provider below for <span style={{ fontWeight: '800' }}>free access</span> to
                    tournaments and exclusive content or create a free account
                    to get in on the action.
                  </Typography>
                  <FormControl sx={{ mt: 3 }} fullWidth size="large">
                    <InputLabel id="demo-simple-select-label">{loadingProviders ? 'Loading Internet Providers...' : 'Choose Your Internet Provider'}</InputLabel>
                    <Select
                      fullWidth
                      size="large"
                      label={loadingProviders ? 'Loading Internet Providers...' : 'Choose Your Internet Provider'}
                      variant='outlined'
                      value={providerSelection}
                      onChange={(event) => {
                        handleProviderSelection(event.target.value);
                      }}
                    >
                      {(providers?.length > 0) &&
                        providers.map((provider, index) =>
                          <MenuItem key={index} value={index}>
                            {provider.name}
                          </MenuItem>
                        )
                      }
                      {/* <MenuItem value='noProvider'>
                        Provider Not Listed
                      </MenuItem> */}
                    </Select>
                  </FormControl>
                  {/* <Divider sx={{ my: 3 }}>
                    <Typography variant="body1">
                      OR
                    </Typography>
                  </Divider> */}
                  <Typography variant="body1" textAlign='center'>
                    <Button fullWidth size="large" sx={{ paddingY: 1.8, mt: 3, backgroundColor: 'rgba(144, 202, 249, 0.08)', color: 'white', '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.2)' } }} color="primary" href="/register?inviteCode=true">
                      Sign Up With Invite Code
                    </Button>
                  </Typography>
                  <Divider sx={{ my: 3 }}>
                    <Typography variant="body1">
                      OR
                    </Typography>
                  </Divider>
                  <Typography variant="body1" textAlign='center'>
                    <Button fullWidth size="large" sx={{ paddingY: 1.8, backgroundColor: 'rgba(144, 202, 249, 0.08)', color: 'white', '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.2)' } }} color="primary" href="/dashboard">
                      Check Out Our Events
                    </Button>
                  </Typography>
                </Grid>
              }
              {user &&
                <Grid item xs={12} sm={6} paddingX={3.5} sx={{ pt: { xs: 0, sm: 5, md: 0 } }}>
                  <Typography
                    component="h1"
                    variant="h1"
                    sx={{ fontWeight: 100, fontSize: { xs: '2.3em', md: '2.9em' }, fontWeight: '500', textAlign: 'center' }}
                    mb={2}
                    paddingTop={{ xs: 2, sm: 0 }}
                  >
                    Welcome Back, {user.firstName}!
                  </Typography>
                  <Typography variant="body1" mb={4} textAlign='center' fontWeight='600'>
                    {user.provider ? <>You're getting <b>free access</b> to tournaments and exclusive content thanks to {user?.provider?.name}</> : 'Find tournaments, game nights, and other content to get in on the action.'}
                  </Typography>
                  <Stack sx={{ flexDirection: { xs: 'column', md: 'row' } }} justifyContent='space-between' gap={2}>
                    <Button fullWidth size="large" sx={{ paddingY: 1.8, backgroundColor: 'rgba(144, 202, 249, 0.08)', color: 'white', '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.2)' } }} color="primary" href="/dashboard/app">
                      <Typography variant="body1" textAlign='center'>
                        View Dashboard
                      </Typography>
                    </Button>
                    <Button fullWidth size="large" sx={{ paddingY: 1.8, backgroundColor: 'rgba(144, 202, 249, 0.08)', color: 'white', '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.2)' } }} color="primary" href="/dashboard/myevents">
                      <Typography variant="body1" textAlign='center'>
                        View Your Events
                      </Typography>
                    </Button>
                  </Stack>
                </Grid>
              }
            </Grid>
          </Container>
          {!user &&
            <Box position='absolute' top={20} left={20}>

              <Button fullWidth size="large" sx={{ paddingY: 1, backgroundColor: 'rgba(144, 202, 249, 0.08)', color: 'white', '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.2)' } }} color="primary" href={user ? '/dashboard' : "/login"}>
                {user ? user.username : 'Log In'}
              </Button>

            </Box>
          }
        </Grid>
        {/* Top Gradient overlay and corner image */}
        <div style={{ background: `${isMd ? 'url(/images/top_background.webp) no-repeat max(100%, 60vw) 100%,' : ''} linear-gradient(120deg, rgba(0,97,142,0.8) 0%, rgba(80,181,99,0.8) 100%)`, position: 'absolute', bottom: '0', left: '0', right: '0', top: '0', zIndex: '-50' }}></div>
        {!user &&
          <LogoHex style={{ height: 'min(600px, 60vw)', width: 'min(600px, 60vw)', backgroundColor: '#7bb842', position: 'absolute', top: 'max(-115px, -14vw)', right: 'max(-100px, -13vw)' }}>
            <img src="/images/white-logo-tall.png" alt="FGN Logo" style={{ height: 'min(350px, 28vw)', width: 'min(350px, 28vw)', maxWidth: 'unset', margin: 'min(150px, 18vw) 0 min(100px, 10vw)  min(110px, 13vw)', objectFit: 'contain' }} />
          </LogoHex>
        }
      </Grid>

      {/* <div class="container-fluid container-main vh-100 d-flex" style={{zIndex: '9000'}}>
          <div class="container mx-auto my-auto text-center py-5">
            <img src="images/white-logo.png" class="img-fluid top-logo" /><br />
            <button type="button" class="btn btn-light" onClick="scrollToSection('watch-video')" style={{backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: '10px 20px'}}><i class="bi bi-play-circle me-1"></i> Watch Video</button>
          </div>
        </div> */}

      <Grid
        container
        id="fiber-is-for-gaming"
        data-scroll-to="true"
        className="vh-100"
        sx={{ backgroundColor: '#194271', overflowX: 'hidden' }}
        paddingBottom={20}
      >
        <Grid item xs={12} sx={{ background: 'url(/images/photo_background_1.webp) no-repeat top right, linear-gradient(330deg, rgba(0,255,51,0.4) 0%, rgba(0,255,51,0) 45%), radial-gradient(circle at top left, rgba(0,255,51,1) 0%, rgba(0,255,51,0) 40%)', backgroundSize: 'contain' }}>
          <Grid container alignItems="center" className="vh-100">
            <Grid xs={12} marginY="auto">
              <Grid container spacing={2} marginTop={0} alignItems='center'>
                <Grid item xs={12} md={12} lg={8} xl={8} height='100vh' sx={{ color: '#FFF', background: { lg: 'linear-gradient(90deg, rgba(25,66,113,0.7609418767507002) 80%, rgba(25,66,113,0) 100%)', xs: 'rgba(25,66,113,0.80)' } }}>
                  <Grid container height='100vh'>
                    <Grid marginY='auto' paddingLeft={{ xs: 3, md: 10, lg: 20, xl: 45 }} paddingRight={{ xs: 3, md: 0 }} paddingTop={{ xs: 15, md: 10 }} paddingY={10} paddingBottom={20}>
                      <Typography component='h3' variant="h3" marginBottom={8} fontSize={{ xs: '2em', md: '3em' }} textAlign={{ xs: 'center', md: 'left' }}>
                        Get access to <b>exclusive tournaments</b> and <b>events</b> every single week
                      </Typography>
                      <List dense>
                        <ListItem disablePadding sx={{ marginBottom: '10px' }}>
                          <ListItemIcon color="#FFFFFF">
                            <SportsEsports fontSize="large" sx={{ color: '#65c85f' }} />
                          </ListItemIcon>
                          <ListItemText color="#FFFFFF">
                            <Typography component='h5' variant="h5" fontSize={{ xs: '1.2em', md: '2em' }}>
                              Weekly game nights playing all the biggest titles
                            </Typography>
                          </ListItemText>
                        </ListItem>
                        <ListItem disablePadding sx={{ marginBottom: '10px' }}>
                          <ListItemIcon color="#FFFFFF">
                            <SportsEsports fontSize="large" sx={{ color: '#65c85f' }} />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography component='h5' variant="h5" fontSize={{ xs: '1.2em', md: '2em' }}>
                              Professionally-casted live streamed broadcasts
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>



      <Grid
        container
        id="fiber-is-for-gaming"
        data-scroll-to="true"
        sx={{ backgroundColor: '#194271' }}
      >
        <GameLogoContainer container sx={{ backgroundColor: '#1162ae' }} paddingTop={7} paddingBottom={3} marginTop={{ xs: -20, md: -30 }} zIndex={200}>
          <Grid item xs={12} textAlign='center' color='#FFF' marginBottom={3}>
            <Typography component='h3' variant="h3" paddingX={3} fontSize={{ xs: '2em', md: '3em' }}>
              Featuring All Of Your Favorite Titles
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ overflowX: 'hidden' }} marginTop={{ xs: -2, md: -5 }} marginBottom={2}>
            <Marquee gradientColor={[17, 98, 174]} speed={40}>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/FIFA Logo.svg" alt="FIFA Logo" />
                <GameLogo src="/images/logos/Fortnite Logo.svg" alt="Fortnite Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Halo Infinite Logo.svg" alt="Fortnite Logo" />
                <GameLogo src="/images/logos/League of Legends Logo.svg" alt="League of Legends Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Overwatch 2 Logo.svg" alt="Overwatch 2 Logo" />
                <GameLogo src="/images/logos/Rocket League Logo.svg" alt="Rocket League Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Smash Bros Logo.svg" alt="Smash Bros Logo" />
                <GameLogo src="/images/logos/The Show 93 Logo.svg" alt="The Show 93 Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/FIFA Logo.svg" alt="FIFA Logo" />
                <GameLogo src="/images/logos/Fortnite Logo.svg" alt="Fortnite Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Halo Infinite Logo.svg" alt="Fortnite Logo" />
                <GameLogo src="/images/logos/League of Legends Logo.svg" alt="League of Legends Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Overwatch 2 Logo.svg" alt="Overwatch 2 Logo" />
                <GameLogo src="/images/logos/Rocket League Logo.svg" alt="Rocket League Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Smash Bros Logo.svg" alt="Smash Bros Logo" />
                <GameLogo src="/images/logos/The Show 93 Logo.svg" alt="The Show 93 Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/FIFA Logo.svg" alt="FIFA Logo" />
                <GameLogo src="/images/logos/Fortnite Logo.svg" alt="Fortnite Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Halo Infinite Logo.svg" alt="Fortnite Logo" />
                <GameLogo src="/images/logos/League of Legends Logo.svg" alt="League of Legends Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Overwatch 2 Logo.svg" alt="Overwatch 2 Logo" />
                <GameLogo src="/images/logos/Rocket League Logo.svg" alt="Rocket League Logo" />
              </div>
              <div style={{ marginLeft: '30px', marginRight: '30px' }}>
                <GameLogo src="/images/logos/Smash Bros Logo.svg" alt="Smash Bros Logo" />
                <GameLogo src="/images/logos/The Show 93 Logo.svg" alt="The Show 93 Logo" />
              </div>
            </Marquee>
          </Grid>
        </GameLogoContainer>
      </Grid>

      {/* <div class="container-fluid info-container bg-light-green vh-100" style={{ zIndex: '9000' }} id="fiber-is-for-gaming" data-scroll-to="true">
        <div class="container mx-auto text-center vh-100">
          <div class="row d-flex vh-100">
            <div class="col-12 mt-auto">
              <h2>Fiber Is for Gaming</h2>
              <p>Delight Your Subscribers. Attract More Prospects. Build a Gaming Community.</p>
              <button type="button" class="btn btn-blue mt-3" onClick="scrollToSection('join-list')"><i class="bi bi-joystick me-1"></i> Get Into the Game</button>
            </div>
            <div class="col-12 mt-auto">
              <img src="images/svg/red-team-fight-in-cyber-war-game.svg" class="img-fluid mt-auto" />
            </div>
          </div>
        </div>
      </div> */}

      {/* <Grid
        container
        id="watch-video"
        data-scroll-to="true"
        className="info-container bg-blue vh-100"
        paddingX={2}
      >
        <Grid item marginX="auto">
          <Grid container alignItems="space-between" className="vh-100">
            <Grid xs={12} marginY="auto" textAlign="center">
              <h2 class="pb-5">Watch the Video</h2>
              <video
                class="teaser-video"
                controls
                style={{ marginBottom: "-10px", backgroundColor: "black" }}
              >
                <source
                  src="/video/fiber-gaming-network-teaser.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <br />
              <img
                src="/images/svg/gaming-pad-NEW.svg"
                class="img-fluid mt-auto"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid> */}

      {/* <div class="container-fluid info-container bg-blue vh-100 py-4" style={{ zIndex: '9000' }} id="watch-video" data-scroll-to="true">
        <div class="container mx-auto text-center vh-100">
          <div class="row d-flex vh-100">
            <div class="col-12 my-auto">
              <h2 class="pb-5">Watch the Video</h2>
              <video class="teaser-video" controls style={{ marginBottom: '-10px', backgroundColor: 'black' }}>
                <source src="video/fiber-gaming-network-teaser.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <br />
              <img src="images/svg/gaming-pad-NEW.svg" class="img-fluid mt-auto" />
            </div>

          </div>
        </div>
      </div> */}

      <Grid
        container
        id="join-list"
        data-scroll-to="true"
        paddingX={2}
        sx={{ overflowX: 'hidden', background: 'url(/images/bottom_lines.webp) no-repeat max(100%, 60vw) 100% / 400px, radial-gradient(circle at bottom right, rgba(80,181,99,1) 0%, rgba(0,97,142,1) 100%)' }}
        color='#FFFFFF'
      >
        <Grid item marginX="auto">
          <Grid container paddingX={{ xs: 2, md: 0 }} justifyContent='center' minHeight='100vh'>
            <Grid item xs={12} md={5.1} marginTop={{ xs: 'auto' }} marginBottom={5} textAlign="center">
              <Typography component='h2' variant="h2" fontSize={{ xs: '2.3em', md: '4em' }} fontWeight={800} marginBottom={{ xs: 3 }} paddingTop={{ xs: 18 }}>
                The Game Is On!
              </Typography>
              <Button fullWidth size="large" sx={{ paddingY: 1.8, mb: 5, backgroundColor: 'black', borderColor: 'black', color: 'white', '&:hover': { backgroundColor: 'black', borderColor: 'black', color: 'white' } }} variant="outlined" color="primary" href="/dashboard">
                View Events
              </Button>
              <Divider sx={{ marginBottom: 5 }} />
              <Typography variant="h4" textAlign='center' sx={{ fontSize: { xs: 28, md: 35 } }}>
                Follow us on our socials
              </Typography>
            </Grid>
            <Grid item xs={12} md={7.1}>
              <Stack direction="row" width='100%' justifyContent='space-around' alignItems="center" spacing={1}>
                <IconButton size='large' href='https://www.youtube.com/channel/UClRFypeJY-fbj-7mlKs1GdQ' target='_blank'>
                  <Box sx={{ aspectRatio: '1/1' }}>
                    <FontAwesomeIcon style={{ fontSize: 50, padding: 10, paddingTop: 13 }} icon={faYoutube} />
                  </Box>
                </IconButton>
                <IconButton size='large' href='https://www.twitch.tv/fibergaming_' target='_blank'>
                  <Box sx={{ aspectRatio: '1/1' }}>
                    <FontAwesomeIcon style={{ fontSize: 40, padding: 15, paddingTop: 18 }} icon={faTwitch} />
                  </Box>
                </IconButton>
                <IconButton size='large' href='https://www.facebook.com/fibergamingnetwork' target='_blank'>
                  <Box sx={{ aspectRatio: '1/1' }}>
                    <FontAwesomeIcon style={{ fontSize: 40, padding: 15 }} icon={faFacebook} />
                  </Box>
                </IconButton>
              </Stack>
              <Stack direction='row' justifyContent={'center'} spacing={3} mt={3}>
                <Typography variant="body1" textAlign='center'>
                  <Link href="https://fibergamingnetwork.com/FGNTermsofService.html" target="_BLANK">
                    Terms of Service
                  </Link>
                </Typography>
                <Typography variant="body1" textAlign='center'>
                  <Link href="https://fibergamingnetwork.com/FGNPrivacyPolicy.html" target="_BLANK">
                    Privacy Policy
                  </Link>
                </Typography>
              </Stack>
            </Grid>
            {/* <Grid xs={12} textAlign="center" marginBottom={{ xs: 8 }}>
              <Button
                type="submit"
                className="btn btn-blue"
                href="https://calendly.com/rgilbert-dxtel/fgn-intro-meetings"
                target="_blank"
              >
                BOOK A DEMO
              </Button>
            </Grid> */}
            {/* <Grid xs={12} textAlign="center" marginBottom={{ xs: -30, md: 0 }}>
              <form
                id="contact-form"
                style={{
                  marginBottom: "20px",
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                <div class="mb-3 text-start " style={{ marginBottom: "10px" }}>
                  <StyledInput
                    type="firstlastname"
                    name="name"
                    class="form-control"
                    id="form-name"
                    placeholder="Name"
                    required
                  />
                </div>
                <div class="mb-3 text-start " style={{ marginBottom: "10px" }}>
                  <StyledInput
                    type="companyname"
                    name="company"
                    class="form-control"
                    id="form-companyname"
                    placeholder="Company Name"
                  />
                </div>
                <div class="mb-3 text-start " style={{ marginBottom: "10px" }}>
                  <StyledInput
                    type="email"
                    name="email"
                    class="form-control"
                    id="form-email"
                    placeholder="Business Email"
                    required
                  />
                </div>
                <div class="">
                  <Button
                    type="submit"
                    className="btn btn-blue"
                    fullWidth
                  >
                    BOOK A DEMO
                  </Button>
                  <br />
                  <label class="txt-light mt-2 my-auto message-sent">
                    Thanks!
                  </label>
                </div>
              </form>
            </Grid> */}
            <Grid item xs={12} marginTop="auto" textAlign="center">
              <img
                src="/images/svg/games-and-esports.svg"
                class="img-fluid"
                style={{ maxHeight: "300px", marginTop: "auto" }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <div class="container-fluid info-container bg-green vh-100" style={{ zIndex: '9000' }} id="join-list" data-scroll-to="true">
        <div class="container mx-auto text-center vh-100">
          <div class="row d-flex vh-100 pt-5">
            <div class="col-12 mt-auto mb-4">
              <h2>It's Time to Get in the Game</h2>
              <p>Something big is coming. Join our list and be the first to know.</p>
            </div>
            <div class="col-12 mt-auto">
              <div class="w-100 d-flex mb-4">
                <form id="contact-form" class="mx-auto mb-5">
                  <div class="mb-3 text-start ">
                    <input type="firstlastname" name="name" class="form-control" id="form-name" placeholder="Name" required />
                  </div>
                  <div class="mb-3 text-start ">
                    <input type="companyname" name="company" class="form-control" id="form-companyname" placeholder="Company Name" />
                  </div>
                  <div class="mb-3 text-start ">
                    <input type="email" name="email" class="form-control" id="form-email" placeholder="Business Email" required />
                  </div>
                  <div class="">
                    <button type="submit" class="btn btn-blue w-100"><i class="bi bi-send-check-fill me-1"></i> Submit</button><br />
                    <label class="txt-light mt-2 my-auto message-sent">Thanks for joining!</label>
                  </div>
                </form>
              </div>

              <img src="images/svg/games-and-esports.svg" class="img-fluid mt-auto" style={{ maxHeight: '300px' }} />
            </div>
          </div>
        </div>
      </div> */}

      <div
        class="container-fluid text-center pb-3"
        style={{ position: "fixed", bottom: "0", left: "0", zIndex: "9100" }}
      >
        <i
          class="bi-arrow-down-circle-fill"
          style={{
            fontSize: "2.5em",
            textShadow: "2px 2px 3px rgba(0, 0, 0, 0.13)",
          }}
          id="scroll-down-btn"
          onClick={() => scrollToSection()}
        ></i>
      </div>
    </ThemeProvider>
  );
}
